import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { QBRErrorModalContent } from './QBRErrorModalContent'

interface ISaveSettingsModalProps {
  show: boolean
  isButtonDisabled: boolean
  onCloseButtonClick: () => void
}

export const QBRErrorModal = ({
  show,
  isButtonDisabled,
  onCloseButtonClick,
}: ISaveSettingsModalProps) => {
  const contentProps = useMemo(
    () => ({ onCloseButtonClick, isButtonDisabled }),
    [onCloseButtonClick, isButtonDisabled]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={QBRErrorModalContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={onCloseButtonClick}
    />
  )
}
